"use client"

import React, { useState } from "react"
import { ChevronDown } from "lucide-react"

interface AccordionFieldProps {
  label: string
  children?: React.ReactNode
  defaultOpen?: boolean
}

const AccordionField: React.FC<AccordionFieldProps> = ({
  label,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className="bg-white/60 backdrop-blur-sm border border-gray-200/50 rounded-xl overflow-hidden shadow-sm">
      <button
        type="button"
        onClick={() => setIsOpen(prev => !prev)}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-50/50 transition-colors duration-200"
        aria-expanded={isOpen}
      >
        <span className="text-sm font-medium text-gray-700">{label}</span>
        <ChevronDown
          className={`h-4 w-4 text-gray-400 flex-shrink-0 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className="border-t border-gray-200/50 px-4 py-3">
          {children ?? (
            <p className="text-sm text-gray-400">Sin información adicional</p>
          )}
        </div>
      )}
    </div>
  )
}

export default AccordionField
